// extracted by mini-css-extract-plugin
module.exports = {"root":"documents-block_root__dhXdT"};